import { render, staticRenderFns } from "./LendersCard.vue?vue&type=template&id=56932cdc&scoped=true&"
import script from "./LendersCard.vue?vue&type=script&lang=js&"
export * from "./LendersCard.vue?vue&type=script&lang=js&"
import style0 from "./LendersCard.vue?vue&type=style&index=0&id=56932cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56932cdc",
  null
  
)

export default component.exports